import { Image } from "@storybook"; // Importing the Image component from Storybook

import { LabelDescription } from "components/label-description"; // Importing the LabelDescription component
import { Description } from "components/description"; // Importing the Description component

import "./verify-screen.scss"; // Importing the SCSS file for styling

interface IVerifyScreen {
  image?: string; // Optional image URL or file name to display
  label?: string | JSX.Element; // Optional main label text or element
  footer?: string | JSX.Element; // Optional footer text or element
  description?: string | JSX.Element; // Optional description text or element
  sublabel?: string | JSX.Element; // Optional sublabel text or element
  labelClass?: string; //Optional className for label
  sublabelClass?: string; //Optional className for sublabel
  handleResend?: () => void; //Optional handleResend Button
}

/**
 * VerifyScreen component displays a verification screen with an optional image, label, sublabel, description, and footer.
 *
 * @param {IVerifyScreen} props - The properties object for the VerifyScreen component.
 * @param {string} [props.image] - The image URL or file name to display.
 * @param {string | JSX.Element} [props.label] - The main label text or element to display.
 * @param {string | JSX.Element} [props.sublabel] - The sublabel text or element to display.
 * @param {string | JSX.Element} [props.description] - The description text or element to display.
 * @param {string | JSX.Element} [props.footer] - The footer text or element to display.
 * @param {string} [props.labelClass] - The labelClass foe style your label.
 * * @param {string} [props.sublabelClass] - The sublabelClass foe style your sublabel.
 *
 * @returns {JSX.Element} The rendered VerifyScreen component.
 */
export const VerifyScreen = ({
  image = "",
  label = "",
  sublabel = "",
  description = "",
  footer = "",
  labelClass = "",
  sublabelClass = "",
  handleResend,
}: IVerifyScreen) => {
  return (
    <div className="verify-screen-wrapper">
      {/* Centering the content */}
      <div className="content-center">
      <div className="verify-screen-wrapper__content-box">
          {/* Container for the image and text elements */}
          <div className="flex-column-center gap-8">
            {/* Conditionally render the image if provided */}
            {image && (
              <Image
                fileName={image}
                showLoader // Show a loader while the image is loading
                skeltonHeight={120} // Height of the skeleton loader
                skeltonWidth={121} // Width of the skeleton loader
              />
            )}
            <div className="flex-column-center gap-8">
              {/* Render the label and sublabel using LabelDescription component */}
              <LabelDescription
                label={label}
                description={sublabel}
                labelClass={labelClass}
                sublabelClass={sublabelClass}
              />
              {/* Border line between label and description */}
              <div className="verify-screen-wrapper__border"></div>
              {/* Conditionally render the description if provided */}
              {description && (
                <Description content={description} className="text-center" />
              )}
            </div>
          </div>
          {/* Conditionally render the footer if provided */}
          {footer && (
            <div className="sublabel verify-screen-wrapper__footer">
              {footer} <span onClick={() => handleResend?.()}>Resend</span>{" "}
              {/* Add a 'Resend' action */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
